import React, { useContext, useState } from 'react'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { clsUtils } from 'zlib-utils'
import BackEndAPI from '../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import InputText from '../../DevComponents/InputText'
import ShowText from '../../DevComponents/ShowText'
import Condicional from '../../Layout/Condicional'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import ClsValidacao from '../../Utils/ClsValidacao'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../ImportBackend/Config/emDesenvolvimento'

interface PesquisaInterface {
  cpf: string
  numeroContrato: number | undefined
}

interface BaixaManualPesquisaInterface {
  idContratoParcela: number
  idContrato: number
  vencimento: string
  valor: number
  status: string
  tipoBaixa: string
  dataRecebimento: string
  vrRecebido: number
  vrDescontoRecebido: number
  vrJurosRecebido: number
  vrMultaRecebido: number
  nomeCliente: string
  cpf: string
}

interface DadosBaixaInterface {
  idContratoParcela: number
  dataRecebimento: string
  vrRecebido: number
  vrDescontoRecebido: number
  vrJurosRecebido: number
  vrMultaRecebido: number
}

enum StatusForm {
  Pesquisando,
  Baixando,
  CancelBaixando
}

const ResetDadosBaixa: DadosBaixaInterface = {
  idContratoParcela: 0,
  dataRecebimento: '',
  vrRecebido: 0,
  vrDescontoRecebido: 0,
  vrJurosRecebido: 0,
  vrMultaRecebido: 0
}

export default function BaixaManual() {

  const navigate = useNavigate()
  const clsApi = new BackEndAPI()
  const clsFormatacao = new ClsFormatacao()
  const clsValidacao = new ClsValidacao()

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)
  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ cpf: '', numeroContrato: 0 })
  const [rsPesquisa, setRsPesquisa] = useState<Array<BaixaManualPesquisaInterface>>([])
  const [registroSelecionado, setRegistroSelecionado] = useState<BaixaManualPesquisaInterface | null>(null)
  const [dadosBaixa, setDadosBaixa] = useState<DadosBaixaInterface>(ResetDadosBaixa)
  const [erros, setErros] = useState<{ [key: string]: string }>({})
  const [errosPesquisa, setErrosPesquisa] = useState<{ [key: string]: string }>({})

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    { campo: 'idContrato', cabecalho: 'Contrato', alinhamento: 'left' },
    { campo: 'nomeCliente', cabecalho: 'Cliente', alinhamento: 'left' },
    { campo: 'cpf', cabecalho: 'CPF', alinhamento: 'left' },
    { campo: 'vencimento', cabecalho: 'Vencimento', alinhamento: 'center', format: (v: string) => clsFormatacao.dataMillsToUser(parseInt(v)) },
    { campo: 'valor', cabecalho: 'Valor', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
    { campo: 'status', cabecalho: 'Status', alinhamento: 'center', format: (v: string) => v === 'EM' ? 'Emitida' : 'Quitada' },
    { campo: 'tipoBaixa', cabecalho: 'Tipo Baixa', alinhamento: 'center', format: (v: string) => v === 'U' ? 'Manual' : 'Sistema' },
  ]

  const btFechar = () => navigate('/')

  const calcularVrRecebido = (valor: number, multa: number, juros: number, desconto: number): number => {
    return parseFloat((valor + multa + juros - desconto).toFixed(2))
  }

  const btBaixar = (rs: BaixaManualPesquisaInterface) => {
    setRegistroSelecionado(rs)
    setDadosBaixa({
      idContratoParcela: rs.idContratoParcela,
      dataRecebimento: clsFormatacao.dataAtualFormatoAMD(),
      vrRecebido: rs.valor,
      vrDescontoRecebido: 0,
      vrJurosRecebido: 0,
      vrMultaRecebido: 0
    })
    setErros({})
    setStatusForm(StatusForm.Baixando)
  }

  const btCancelarBaixa = (rs: BaixaManualPesquisaInterface) => {
    setRegistroSelecionado(rs)
    setStatusForm(StatusForm.CancelBaixando)
  }

  const btVoltar = () => {
    setRegistroSelecionado(null)
    setDadosBaixa(ResetDadosBaixa)
    setErros({})
    setStatusForm(StatusForm.Pesquisando)
  }

  const validarPesquisa = (): boolean => {
    let errs: { [key: string]: string } = {}
    const valido = !!pesquisa.cpf || (!!pesquisa.numeroContrato && pesquisa.numeroContrato > 0)
    if (!valido) {
      errs.cpf = 'Informe o CPF ou número do contrato'
      errs.numeroContrato = 'Informe o CPF ou número do contrato'
    }
    setErrosPesquisa(errs)
    return valido
  }

  const validarBaixa = (): boolean => {
    let retorno = true
    let errs: { [key: string]: string } = {}
    retorno = clsValidacao.eData('dataRecebimento', dadosBaixa, errs, retorno)
    setErros(errs)
    return retorno
  }

  const onClickPesquisa = () => {
    if (!validarPesquisa()) return

    const dadosPesquisa: any = {}
    if (pesquisa.cpf) dadosPesquisa.cpf = pesquisa.cpf
    if (pesquisa.numeroContrato && pesquisa.numeroContrato > 0) dadosPesquisa.numeroContrato = pesquisa.numeroContrato

    const query = `
      getParcelasBaixaManual(dados: ${clsUtils.ConverterEmGql(dadosPesquisa)}) {
        idContratoParcela
        idContrato
        vencimento
        valor
        status
        tipoBaixa
        dataRecebimento
        vrRecebido
        vrDescontoRecebido
        vrJurosRecebido
        vrMultaRecebido
        nomeCliente
        cpf
      }
    `
    clsApi.query<Array<BaixaManualPesquisaInterface>>(query, 'getParcelasBaixaManual', 'Pesquisando parcelas...', contexto)
      .then(rs => setRsPesquisa(rs))
  }

  const confirmarBaixa = () => {
    if (!validarBaixa()) return
    const mutation = `
      baixarParcelaManual(dados: ${clsUtils.ConverterEmGql(dadosBaixa)}) {
        ok
        mensagem
      }
    `
    clsApi.mutation<RespostaPadraoInterface>(mutation, 'baixarParcelaManual', 'Baixando parcela...', contexto).then(rs => {
      if (rs.ok) {
        setMensagemState({ ...mensagemState, titulo: 'Confirmado!', exibir: true, mensagem: rs.mensagem, tipo: MensagemTipo.Info, exibirBotao: true })
        btVoltar()
        onClickPesquisa()
      } else {
        setMensagemState({ ...mensagemState, titulo: 'Erro!', exibir: true, mensagem: rs.mensagem, tipo: MensagemTipo.Error, exibirBotao: true })
      }
    })
  }

  const confirmarCancelamentoBaixa = () => {
    if (!registroSelecionado) return
    const mutation = `
      cancelarBaixaParcela(idContratoParcela: ${registroSelecionado.idContratoParcela}) {
        ok
        mensagem
      }
    `
    clsApi.mutation<RespostaPadraoInterface>(mutation, 'cancelarBaixaParcela', 'Cancelando baixa...', contexto).then(rs => {
      if (rs.ok) {
        setMensagemState({ ...mensagemState, titulo: 'Confirmado!', exibir: true, mensagem: rs.mensagem, tipo: MensagemTipo.Info, exibirBotao: true })
        btVoltar()
        onClickPesquisa()
      } else {
        setMensagemState({ ...mensagemState, titulo: 'Erro!', exibir: true, mensagem: rs.mensagem, tipo: MensagemTipo.Error, exibirBotao: true })
      }
    })
  }

  const dadosExibicao = registroSelecionado ? {
    nomeCliente: registroSelecionado.nomeCliente,
    idContrato: registroSelecionado.idContrato.toString(),
    vencimento: clsFormatacao.dataISOtoUser(registroSelecionado.vencimento),
    valor: clsFormatacao.currency(registroSelecionado.valor)
  } : {}

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }}>
        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Baixa Manual de Parcelas
                <Typography variant="body2" gutterBottom>
                  {statusForm === StatusForm.Pesquisando && 'Pesquisar parcelas para baixa ou cancelamento de baixa'}
                  {statusForm === StatusForm.Baixando && 'Informe os dados de recebimento'}
                  {statusForm === StatusForm.CancelBaixando && 'Confirmar cancelamento de baixa manual'}
                </Typography>
              </Typography>
              <IconButton onClick={btFechar}>
                <CloseIcon />
              </IconButton>
            </Grid>

            {/* Pesquisa */}
            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={5}>
                <InputText
                  dados={pesquisa}
                  field='cpf'
                  label='CPF do Cliente'
                  setState={setPesquisa}
                  mask='cpf'
                  erros={errosPesquisa}
                  mapKeyPress={[{ key: 'Enter', onKey: onClickPesquisa }]}
                />
              </Grid>

              <Grid item xs={12} sm={4} sx={{ pl: { sm: 1 } }}>
                <InputText
                  dados={pesquisa}
                  field='numeroContrato'
                  label='Número do Contrato'
                  setState={setPesquisa}
                  tipo='number'
                  erros={errosPesquisa}
                  mapKeyPress={[{ key: 'Enter', onKey: onClickPesquisa }]}
                />
              </Grid>

              <Grid item xs={12} sm={3} sx={{ pl: { sm: 1 }, mt: 2 }}>
                <Button fullWidth variant='contained' onClick={onClickPesquisa}>Pesquisar</Button>
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <DataTable
                  dados={rsPesquisa}
                  cabecalho={Cabecalho}
                  acoes={[
                    {
                      icone: 'payment',
                      toolTip: 'Baixar Parcela',
                      onAcionador: btBaixar,
                      corIcone: 'success.main',
                      onDisabled: (rs: BaixaManualPesquisaInterface) => rs.status !== 'EM'
                    },
                    {
                      icone: 'undo',
                      toolTip: 'Cancelar Baixa Manual',
                      onAcionador: btCancelarBaixa,
                      corIcone: 'warning.main',
                      onDisabled: (rs: BaixaManualPesquisaInterface) => rs.tipoBaixa !== 'U'
                    }
                  ]}
                />
              </Grid>

            </Condicional>

            {/* Formulário de Baixa */}
            <Condicional condicao={statusForm === StatusForm.Baixando}>

              <Grid item xs={12} md={6}>
                <ShowText dados={dadosExibicao} field='nomeCliente' label='Cliente' />
              </Grid>
              <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>
                <ShowText dados={dadosExibicao} field='idContrato' label='Contrato' />
              </Grid>
              <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>
                <ShowText dados={dadosExibicao} field='vencimento' label='Vencimento' />
              </Grid>

              <Grid item xs={12} sm={1} md={4} lg={4}>
              </Grid>

              <Grid item xs={12} sm={9} md={6} lg={4}>

                <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

                  <Grid item xs={12}>
                    <InputText
                      dados={dadosBaixa}
                      field='dataRecebimento'
                      label='Data de Recebimento'
                      setState={setDadosBaixa}
                      tipo='date'
                      mask='00/00/0000'
                      textAlign='right'
                      erros={erros}
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <InputText
                      dados={dadosBaixa}
                      field='vrRecebido'
                      label='Valor Recebido'
                      tipo='currency'
                      textAlign='right'
                      disabled={true}
                      erros={erros}
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <InputText
                      dados={dadosBaixa}
                      field='vrDescontoRecebido'
                      label='Desconto'
                      tipo='currency'
                      textAlign='right'
                      erros={erros}
                      onChange={(v) => setDadosBaixa(prev => ({
                        ...prev,
                        vrDescontoRecebido: v,
                        vrRecebido: calcularVrRecebido(registroSelecionado!.valor, prev.vrMultaRecebido, prev.vrJurosRecebido, v)
                      }))}
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <InputText
                      dados={dadosBaixa}
                      field='vrJurosRecebido'
                      label='Juros'
                      tipo='currency'
                      textAlign='right'
                      erros={erros}
                      onChange={(v) => setDadosBaixa(prev => ({
                        ...prev,
                        vrJurosRecebido: v,
                        vrRecebido: calcularVrRecebido(registroSelecionado!.valor, prev.vrMultaRecebido, v, prev.vrDescontoRecebido)
                      }))}
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <InputText
                      dados={dadosBaixa}
                      field='vrMultaRecebido'
                      label='Multa'
                      tipo='currency'
                      textAlign='right'
                      erros={erros}
                      onChange={(v) => setDadosBaixa(prev => ({
                        ...prev,
                        vrMultaRecebido: v,
                        vrRecebido: calcularVrRecebido(registroSelecionado!.valor, v, prev.vrJurosRecebido, prev.vrDescontoRecebido)
                      }))}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ mt: 3 }}>
                    <Button variant='contained' startIcon={<CheckIcon />} sx={{ mr: 2 }} onClick={confirmarBaixa}>
                      Confirmar Baixa
                    </Button>
                    <Button variant='contained' startIcon={<CloseIcon />} onClick={btVoltar}>
                      Cancelar
                    </Button>
                  </Grid>

                </Grid>

              </Grid>

              <Grid item xs={12} sm={2} md={2} lg={4}>
              </Grid>


            </Condicional>

            {/* Confirmação de Cancelamento de Baixa */}
            <Condicional condicao={statusForm === StatusForm.CancelBaixando}>

              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography variant="body1">
                  Confirma o cancelamento da baixa manual da parcela abaixo? A parcela retornará para o status <strong>Emitida</strong>.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <ShowText dados={dadosExibicao} field='nomeCliente' label='Cliente' />
              </Grid>
              <Grid item xs={12} sm={2} sx={{ pl: { sm: 1 } }}>
                <ShowText dados={dadosExibicao} field='idContrato' label='Contrato' />
              </Grid>
              <Grid item xs={12} sm={2} sx={{ pl: { sm: 1 } }}>
                <ShowText dados={dadosExibicao} field='vencimento' label='Vencimento' />
              </Grid>
              <Grid item xs={12} sm={2} sx={{ pl: { sm: 1 } }}>
                <ShowText dados={dadosExibicao} field='valor' label='Valor' />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Button variant='contained' color='warning' startIcon={<CheckIcon />} sx={{ mr: 2 }} onClick={confirmarCancelamentoBaixa}>
                  Confirmar Cancelamento
                </Button>
                <Button variant='contained' startIcon={<CloseIcon />} onClick={btVoltar}>
                  Voltar
                </Button>
              </Grid>

            </Condicional>

          </Grid>
        </Paper>
        <ExibirJSONDev exibir={EMDESENVOLVIMENTO && false} oque={['pesquisa', pesquisa, 'dadosBaixa', dadosBaixa]} />
      </Container>
    </>
  )
}
